var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"info-icon",class:_vm.classes},[_c('ion-icon',{attrs:{"name":_vm.ICONS.information}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }